import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

createListButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                null,
                null,
                null,
            ])}
    `,
};
createListButtonStyles.createListButton = {
    variant:"secondary",
    // MGBW: pin button text to #545454 (matching Surya) and suppress hover/active
    // effects so the outline button rests and interacts identically to Surya.
    // Render-time brand check (SSR-safe); no-op for Surya / Global Views.
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            isMgbwWebsite()
                ? css`
                      span[class^="TypographyStyle"] {
                          color: #545454 !important;
                          font-weight: 400 !important;
                      }
                      &:not(:disabled):hover,
                      &:active,
                      &:focus {
                          color: #545454 !important;
                          border-color: ${theme.button?.secondary?.color} !important;
                          background: transparent !important;
                          span[class^="TypographyStyle"] {
                              color: #545454 !important;
                              font-weight: 400 !important;
                          }
                      }
                  `
                : null}
    `,
};
createListButtonStyles.createListModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalTitle: css`
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        `,
        headlineTypography: css`
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;
        `,
        modalContent: css`
            font-family: ${TYPOGRAPHY.fontFamily.base} !important;

            *,
            p,
            span,
            div,
            a,
            button,
            label,
            input,
            select,
            textarea,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-family: ${TYPOGRAPHY.fontFamily.base} !important;
            }
        `,
    },
};
